export default {
  discount_badge: '{{value}} reducere',
  high_caffeine_warning_required: 'Cofeină ridicată',
  pfand: 'Incl. {{value}} garanție',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcool',
};
